import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ModalManagerState from 'flarum/common/states/ModalManagerState';

/**
 * Modals on touch devices open at the top, with nothing focused.
 *
 * Core's focus trap focuses the first tabbable control when a modal opens,
 * and FormModal focuses the first input outright. On a phone the modal is
 * full-screen and `.ModalManager` is the scroll container, so iOS scrolls it
 * to that control — a modal taller than the screen opens at its bottom — and
 * a focused <select> pops the picker. Nobody asked for a keyboard by opening
 * a modal, so on touch devices the focus is dropped the moment it lands and
 * the container is pinned to the top for the first moments after opening.
 * Hooked on the manager rather than on each modal, so it covers every modal
 * on the site — ours and core's — including subclasses that override onready.
 */
const touch = () => (window.matchMedia?.('(pointer: coarse)').matches ?? false) || 'ontouchstart' in window;
let openedAt = 0;
const pin = () => {
  const manager = document.querySelector('.ModalManager');
  if (manager) manager.scrollTop = 0;
  document.querySelectorAll('.Modal-body').forEach(b => b.scrollTop = 0);
};
const release = () => {
  const active = document.activeElement;
  if (active && active !== document.body && active.closest('.ModalManager')) active.blur();
};
export default function touchModals() {
  extend(ModalManagerState.prototype, 'show', function () {
    if (!touch()) return;
    openedAt = Date.now();
    // The dialog is rendered a frame later, and iOS keeps scrolling for a
    // few hundred milliseconds after focus — hence the schedule, not one call.
    [0, 50, 150, 300, 600, 900].forEach(ms => setTimeout(() => {
      release();
      pin();
    }, ms));
  });

  // Catch the focus the trap gives out, before Safari reveals the element.
  document.addEventListener('focusin', e => {
    if (!touch() || Date.now() - openedAt > 1200) return;
    const target = e.target;
    if (!target?.closest?.('.ModalManager')) return;
    target.blur();
    pin();
  }, true);
}

// Keep a reference so tree-shaking never drops the side effect.
void app;
flarum.reg.add('linkrobins-lr-monitoring', 'touchModals', touchModals);